export enum RequestAddressErrorKey {
  FROM_API = 'fromApi',
  NEARBY_CITY = 'nearbyCity',
  KM_RESTRICTION = 'addressKMRestriction',
  COVERAGE = 'addressCoverage',
  INVALID = 'addressInvalid',
  DECLARED_VALUE = 'addressDeclaredValue',
}
